import { render, staticRenderFns } from "./SortingItemLayout.vue?vue&type=template&id=542756f2&scoped=true&"
import script from "./SortingItemLayout.vue?vue&type=script&lang=js&"
export * from "./SortingItemLayout.vue?vue&type=script&lang=js&"
import style0 from "./SortingItemLayout.vue?vue&type=style&index=0&id=542756f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542756f2",
  null
  
)

export default component.exports